module.exports = __webpack_public_path__ + "img/Group 2.6f141e03.png";